<template>
  <div class="content-well bg-white shadow-1 pt-3 pb-3 pr-2 pl-2 pr-lg-4 pl-lg-4">
    <div v-if="batch.hold && !onDeckOverride">
      <h4 class="text-success">On Deck</h4>
      <p class="text-primary">This batch is on deck and can be ordered when other batches are sold out or added to cart.</p>
    </div>
    <ProductDisplayStorefront
      v-else-if="showStoreFrontForm() && !disableAdd && !cartNeedsToBeChosen"
      :product="product"
      :batch="batch"
      :cart-items="cartItems"
      :bulk-discounts="bulkDiscounts"
      :active-location="activeLocation"
      @added-product="(product) => $emit('addedProduct', product)"
      @launch-p-t-o-modal="(val) => $emit('launchPTOModal', val)"
    />
    <div v-if="cartNeedsToBeChosen">
      <h5>Please choose a location to add this product to your cart</h5>
    </div>
    <BushelBtn v-else-if="disableAdd" class="btn-block my-3" variant="success" @click="$emit('contactButtonClicked')">
      Contact Us To Order
    </BushelBtn>
    <ProductDisplayDate v-if="batch.harvest_date" :name="'Harvest Date'" :date="batch.harvest_date" />
    <ProductDisplayDate v-if="batch.extraction_date" :name="'Extraction Date'" :date="batch.extraction_date" />
    <ProductDisplayDate v-if="batch.dry_date" :name="'Dry Date'" :date="batch.dry_date" />
    <ProductDisplayDate v-if="batch.test_date" name="Test Date" :date="batch.test_date" />
    <ProductDisplayDate v-if="batch.best_by_date" :name="'Expiration Date'" :date="batch.best_by_date" />
    <ProductDisplayDate v-if="batch.in_stock_expected_date && batch.back_order" name="Expected In Stock" :date="batch.in_stock_expected_date" />
    <ProductDisplayDate v-if="batch.production_date" :name="'Production Date'" :date="batch.production_date" />
    <ProductDisplayAge v-if="batch.harvest_date" type="months" :date="batch.harvest_date" />
    <ProductDisplayAge v-else-if="batch.production_date" type="months" :date="batch.production_date" />
  </div>
</template>

<script>
import ProductDisplayAge from "./components/ProductDisplayAge.vue";
import ProductDisplayDate from "./components/ProductDisplayDate.vue";
import ProductDisplayStorefront from "./components/ProductDisplayStorefront.vue";
import { isObjEmpty } from "@/services/helpers";
import { showBatchDocumentsUploadFieldCheck } from "@/services/inventory/showBatchFieldChecks";

export default {
  components: {
    ProductDisplayAge,
    ProductDisplayDate,
    ProductDisplayStorefront,
  },
  props: {
    cartItems: { type: Array },
    product: { type: Object, required: true },
    batch: { type: Object, required: true },
    storeComponentEnabled: { type: Boolean, default: true },
    disableAdd: { type: Boolean, required: true },
    bulkDiscounts: { type: Array, required: true },
    cartNeedsToBeChosen: { type: Boolean, required: true },
    activeLocation: { type: Object },
    onDeckOverride: { type: Boolean, default: false },
  },
  emits: ["addedProduct", "contactButtonClicked", "launchPTOModal"],
  data() {
    return {
      showBatchDocumentsUploadField: showBatchDocumentsUploadFieldCheck(this.product.category.name),
    };
  },
  methods: {
    isObjEmpty,
    showStoreFrontForm() {
      if (this.storeComponentEnabled && !this.showBatchDocumentsUploadField) {
        return true;
      }
      if (this.storeComponentEnabled) {
        return true;
      }
      return false;
    },
    // checkForPotencyDoc() {
    //   let hasDoc = false;
    //   if (!this.isObjEmpty(this.batch) && this.batch.documents && this.batch.documents.length > 0) {
    //     this.batch.documents.forEach((doc, index) => {
    //       if (doc.label == 'Potency') {
    //         hasDoc = true;
    //       }
    //     });
    //   }
    //   return hasDoc;
    // },
  },
};
</script>
